// ----------------------------------------------------------------------------
// Component: Testimonial
// ----------------------------------------------------------------------------
//
// A list of testimonials
//
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard, EffectFade, Autoplay } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_testimonial.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--testimonial-quote';
var CAROUSEL_CLASS = 'carousel--testimonial-quote';
var CAROUSEL_SECTION_SELECTOR = '.carousel-section--testimonials';
var CAROUSEL_SECTION_CLASS = 'carousel-section--testimonials';
var CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
var CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';
var CAROUSEL_SECTION_SELECTOR_SIMPLE = '.carousel-section--testimonials-simple';
var CAROUSEL_SECTION_CLASS_SIMPLE = 'carousel-section--testimonials-simple';
var CAROUSEL_SELECTOR_SIMPLE = '.carousel--testimonials';
var CAROUSEL_CLASS_SIMPLE = 'carousel--testimonials';

// -------------------------------------
// Hooks
// -------------------------------------

document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  // Generate unique class for each collection list slider
  element.querySelector(CAROUSEL_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));

  // Generate unique btn classes for slider arrows
  // element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
  // element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);

  // Generate unique btn classes for swiper pagination
  element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    // Optional parameters
    modules: [Navigation, Pagination, A11y, Keyboard, EffectFade, Autoplay],
    slidesPerView: 1,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    a11y: true,
    watchOverflow: true,
    effect: 'fade',
    loop: true,
    speed: 1000,
    watchSlidesProgress: true,
    pagination: {
      el: "".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index),
      clickable: true,
      renderBullet: function renderBullet(bulletIndex, className) {
        return "<span type=\"button\" tabindex=\"0\" class=\"".concat(className, "\"></span>");
      }
    },
    hashNavigation: {
      watchState: true
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: false
    },
    on: {
      slideChange: function slideChange() {
        var bullets = element.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index, " .swiper-pagination-bullet"));
        bullets.forEach((bullet, bulletIndex) => {
          if (bulletIndex === swiper.activeIndex) {
            bullet.setAttribute('aria-current', 'true');
          } else {
            bullet.removeAttribute('aria-current');
          }
        });
      },
      afterInit: function afterInit(swiper) {
        // Play/Pause control button
        var controlBtn = element.querySelector('.testimonial__control');
        var paginationContainer = element.querySelector("".concat(CAROUSEL_SELECTOR, "-").concat(index) + ' .pagination__container');
        var activeBullet = element.querySelector('.swiper-pagination-bullet-active');
        controlBtn.addEventListener('click', function () {
          if (this.getAttribute('aria-pressed') === 'false') {
            swiper.autoplay.stop();
            this.querySelector('.screen-reader-text').textContent = 'Play';
            paginationContainer.classList.add('play');
            paginationContainer.classList.remove('pause');
            this.setAttribute('aria-pressed', 'true');
            activeBullet.style.animationPlayState = 'paused';
          } else {
            swiper.autoplay.start();
            this.querySelector('.screen-reader-text').textContent = 'Pause';
            paginationContainer.classList.add('pause');
            paginationContainer.classList.remove('play');
            this.setAttribute('aria-pressed', 'false');
          }
        });

        // Move to corresponding slide when pagination bullet is clicked or activated via keyboard
        var paginationBullets = element.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index, " .swiper-pagination-bullet"));
        paginationBullets.forEach((bullet, bulletIndex) => {
          bullet.addEventListener('click', e => {
            e.preventDefault(); // optional if bullets are <a> tags
            swiper.slideTo(bulletIndex);
          });
          bullet.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault(); // prevent scrolling on Space
              swiper.slideTo(bulletIndex);
            }
          });
        });
      }
    }
  });
  swiper.slides.forEach(function (slide, index) {
    var slideLink = slide.querySelector('a');
    slideLink.addEventListener('focus', function () {
      swiper.slideTo(index);
    });
  });
});

// Simple Testimonial slides handling
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR_SIMPLE).forEach((element, index) => {
  // Generate unique class for each collection list slider
  element.querySelector(CAROUSEL_SELECTOR_SIMPLE).classList.add("".concat(CAROUSEL_CLASS_SIMPLE, "-").concat(index));

  // Generate unique btn classes for slider arrows
  element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS_SIMPLE, "-btn-prev-").concat(index));
  element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS_SIMPLE, "-btn-next-").concat(index));

  // Generate unique btn classes for swiper pagination
  element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS_SIMPLE, "-pagination-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS_SIMPLE, "-").concat(index), {
    // Optional parameters
    modules: [Navigation, Pagination, A11y, Keyboard],
    slidesPerView: 1,
    spaceBetween: 15,
    observer: true,
    observeParents: true,
    a11y: true,
    watchOverflow: true,
    navigation: {
      nextEl: "".concat(CAROUSEL_SECTION_SELECTOR_SIMPLE, "-btn-next-").concat(index),
      prevEl: "".concat(CAROUSEL_SECTION_SELECTOR_SIMPLE, "-btn-prev-").concat(index)
    },
    pagination: {
      el: "".concat(CAROUSEL_SECTION_SELECTOR_SIMPLE, "-pagination-").concat(index),
      clickable: true,
      renderBullet: function renderBullet(bulletIndex, className) {
        return "<span type=\"button\" tabindex=\"0\" class=\"".concat(className, "\"></span>");
      }
    },
    on: {
      slideChange: function slideChange() {
        var bullets = element.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR_SIMPLE, "-pagination-").concat(index, " .swiper-pagination-bullet"));
        bullets.forEach((bullet, bulletIndex) => {
          if (bulletIndex === swiper.activeIndex) {
            bullet.setAttribute('aria-current', 'true');
          } else {
            bullet.removeAttribute('aria-current');
          }
        });
      }
      // afterInit: function (swiper) {
      //     // Play/Pause control button
      //     const controlBtn = element.querySelector('.testimonial__control');
      //     const paginationContainer = element.querySelector(`${CAROUSEL_SELECTOR}-${index}` + ' .pagination__container');
      //     const activeBullet = element.querySelector('.swiper-pagination-bullet-active');

      //     controlBtn.addEventListener('click', function () {
      //         if (this.getAttribute('aria-pressed') === 'false') {
      //             swiper.autoplay.stop();
      //             this.querySelector('.screen-reader-text').textContent = 'Play';
      //             paginationContainer.classList.add('play');
      //             paginationContainer.classList.remove('pause');
      //             this.setAttribute('aria-pressed', 'true');
      //             activeBullet.style.animationPlayState = 'paused';

      //         } else {
      //             swiper.autoplay.start();
      //             this.querySelector('.screen-reader-text').textContent = 'Pause';
      //             paginationContainer.classList.add('pause');
      //             paginationContainer.classList.remove('play');
      //             this.setAttribute('aria-pressed', 'false');
      //         }
      //     });
      // },
    }
  });
});